const RegisterTermsAndConditions = () => {
    return (
        <>
            <div className="grid">
                <div className="col-12">
                    <div className="card docs">
                        <h6>1. Acceptance of Terms:</h6>
                        By accessing or using our e-commerce login website, you agree to comply with and be bound by these terms and conditions. If you do not agree to these terms, please do not use our website.
                        <h6>2. User Accounts</h6>
                        a. To access certain features of the website, you may need to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
                        b. You must provide accurate and complete information when creating an account. You agree to notify us immediately of any unauthorized use of your account.
                        <h6>3. User Conduct</h6>
                        a. You agree to use the website in accordance with all applicable laws and regulations.
                        b. You may not use the website for any unlawful or prohibited purpose, including but not limited to:
                        Violating any applicable laws or regulations.
                        Impersonating another person.
                        Uploading or transmitting viruses or any other malicious code.
                        Interfering with the proper functioning of the website.
                        <h6>4. Intellectual Property</h6>
                                                
                        a. The content on the website, including but not limited to text, graphics, logos, and images, is the property of the website owner and is protected by copyright and other intellectual property laws.
                        b. You may not use, reproduce, distribute, or create derivative works based on the content without the express written consent of the website owner.

                        <h6>5. Privacy Policy</h6>
                        a. Our Privacy Policy governs the collection, use, and disclosure of your personal information. By using the website, you agree to the terms of our Privacy Policy.
                        <h6>6. Limitation of Liability</h6>
                        a. To the fullest extent permitted by law, the website owner shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues.
                        <h6>7. Termination</h6>
                        a. The website owner reserves the right to terminate or suspend your account and access to the website at any time, without notice, for any reason.
                        <h6>8. Governing Law</h6>
                        a. These terms and conditions are governed by the laws of India.
                        <h6>9. Changes to Terms</h6>
                        a. The website owner reserves the right to modify these terms and conditions at any time. Your continued use of the website after such modifications will constitute your acknowledgment of the modified terms.
                        <h6>10. Contact Information</h6>
                        If you have any questions about these terms and conditions, please contact us at mahesha@desiri.in
                    </div>
                </div>
            </div>
        </>
    );
};

export default RegisterTermsAndConditions;



